import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  width: 326px;
  max-height: 200px;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ShowOptions = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  top: 40px;
  background: #fff;
  width: 326px;
  flex-direction: column;
  z-index: 9;
  border: ${({ haveResults }) => (haveResults ? '1px solid #e9edf1' : 'none')};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;
export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  height: 42px;
  width: 100%;
  align-items: center;
  flex: 1;
`;
export const Div = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  height: 42px;
  /* margin-top: 22px; */
`;

export const Search = styled.input<SearchProps>`
  width: 326px;
  height: 42px;
  border-radius: ${({ haveResults }) => (haveResults ? '8px 8px 0 0' : '8px')};
  font-size: 14px;
  color: ${beam.font.primary};
  background: #fff;
  align-items: start;
  padding: 10px 16px;
  border: 1px solid #e9edf1;
  border-bottom: ${({ haveResults }) =>
    haveResults ? 'none' : '1px solid #e9edf1'};
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  cursor: auto;
  /* borders/light-border */
  flex: 1;
  -webkit-appearance: none;
  ::placeholder {
    color: #787878;
  }
  :disabled {
    cursor: default;
  }
  &.close {
    padding-right: 36px;
  }
  &[data-disabled='true'] {
    background-color: #f5f7fb;
    border: 1px solid #e9edf1;
    color: #8f95b2;
  }
`;
interface SearchImgProps {
  isDisabled?: boolean;
}
export const SearchImg = styled.img<SearchImgProps>`
  left: 12px;
  position: absolute;
  z-index: 1;
  margin-right: -10px;
  margin-top: -5px;
  visibility: ${({ isDisabled }) => (isDisabled ? 'hidden' : 'visible')};
`;

export const Line = styled.div`
  border-top: 1px solid #e9edf1;
  width: 302px;
  display: flex;
  position: absolute;
  bottom: 0;
  margin-left: 16px;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.div`
  cursor: pointer;
  padding: 5px 8px 0 8px;
  margin-left: -34px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const StyledOption = styled.text`
  display: flex;
  margin-left: 8px;
  margin-right: 8px;
  user-select: none;
  align-items: flex-start;
  margin-top: 8px;
  padding: 8px 0;
  justify-content: flex-start;
  text-align: start;
  width: 322px;
  padding-left: 24px;
  cursor: pointer;
  :hover {
    border-radius: 8px;
    background: ${beam.background.hover};
  }
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
  margin-right: 8px;
  margin-top: 8px;
`;

export const BlueButton = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  font-style: normal;

  white-space: nowrap;
  background: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background: transparent;
  border-radius: 8px;
`;
